const MOMENT = new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
const CLOCK = new Intl.DateTimeFormat('ru-RU', { hour: '2-digit', minute: '2-digit', second: '2-digit' })

/** «23.10 14:05» — момент проверки на плитке и в сводке. Нечитаемая дата показывается как пришла, а не прячется. */
export function formatMoment(iso: string): string {
  const date = new Date(iso)
  return Number.isNaN(date.getTime()) ? iso : MOMENT.format(date).replace(',', '')
}

/** «14:05:09» — когда служба сама повторит запрос. */
export function formatClock(iso: string): string {
  const date = new Date(iso)
  return Number.isNaN(date.getTime()) ? iso : CLOCK.format(date)
}

const WORDS = {
  item: ['наименование', 'наименования', 'наименований'],
  pair: ['пара', 'пары', 'пар'],
  marked: ['отмечена', 'отмечено', 'отмечено'],
} as const

/** Склонение по числу: 1 пара, 2 пары, 5 пар. */
export function plural(count: number, kind: keyof typeof WORDS): string {
  const [one, few, many] = WORDS[kind]
  const tail = Math.abs(count) % 100
  const last = tail % 10
  if (tail > 10 && tail < 20) return many
  if (last === 1) return one
  return last >= 2 && last <= 4 ? few : many
}

/** Строка последней проверки на плитке источника (И-2): «23.10 14:05 · 128 пар · 40 отмечено». */
export function summaryLine(summary: { finishedAt: string | null; startedAt: string; pairCount: number; markedCount: number }): string {
  const when = formatMoment(summary.finishedAt ?? summary.startedAt)
  return `${when} · ${summary.pairCount} ${plural(summary.pairCount, 'pair')} · ${summary.markedCount} ${plural(summary.markedCount, 'marked')}`
}
